import React from 'react'

export const Aminities = () => {
    return (

        <>
            {/* ===== AMENITIES ===== */}
            <section style={{ background: "var(--light-bg)" }}>
                <div className="container">
                    <h2 className="zzx_section-title text-center">Filter by Amenity</h2>
                    <p className="zzx_section-sub text-center">
                        Find hotels with exactly what you need
                    </p>
                    <div className="row g-3 justify-content-center mt-2">
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-wifi" />
                                </div>
                                Free WiFi
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-water" />
                                </div>
                                Pool
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-cup-hot-fill" />
                                </div>
                                Breakfast
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-p-square-fill" />
                                </div>
                                Parking
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-activity" />
                                </div>
                                Gym
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-heart-pulse-fill" />
                                </div>
                                Spa
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-basket-fill" />
                                </div>
                                Restaurant
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-house-door-fill" />
                                </div>
                                Family Rooms
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-person-wheelchair" />
                                </div>
                                Accessible
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="zzx_amenity-icon">
                                <div className="zzx_icon-box">
                                    <i className="bi bi-moon-stars-fill" />
                                </div>
                                24hr Desk
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>


    )
}
